import React, { Component } from 'react';
import FX from './functions/functions';
import './css/Calendar.css';

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.today = new Date();
    console.log(React.version);
    this.myRef = React.createRef();
    console.log(this.props.date);
    this.state = {};
    var date;
    if (this.props.date) {
        this.state.from = this.today = FX.parseDate(this.props.date,'Z');
        this.today.setUTCHours(0);
        this.today.setUTCMinutes(0);
        this.today.setUTCSeconds(0);
        
    }
    console.log(this.today);
    this.monthStart = new Date(this.today.getUTCFullYear(), this.today.getMonth(), 1 );
    this.state.monthStart = this.monthStart;
  }
  daysInMonth = (month,year) => {
    return new Date(year, month + 1, 0).getDate();
  }
  backMonth = () => {
    var monthStart = this.monthStart.setMonth(this.monthStart.getMonth()-1);
    this.setState({monthStart:monthStart});
  }
  foreMonth = () => {
    var monthStart = this.monthStart.setMonth(this.monthStart.getMonth()+1);
    this.setState({monthStart:monthStart});
  }
  setter = (d) => {
    console.log(d);
    var y = this.monthStart.getFullYear();
    var m = this.monthStart.getMonth();
    if(this.props.range){
        if((!this.state.from || this.state.to) || new Date(this.monthStart.getFullYear(), this.monthStart.getMonth(), d) < this.state.from){
          this.setState({to : undefined, from : new Date(this.monthStart.getFullYear(), this.monthStart.getMonth(), d)});
        }
        else {
          this.setState({to :  new Date(Date.UTC(this.monthStart.getFullYear(), this.monthStart.getMonth(), d,0,0))});
        }
    }
    else {
        var nd = new Date(Date.UTC(this.monthStart.getFullYear(), this.monthStart.getMonth(), d));
          this.setState({to : undefined, from : nd});
    }
    console.log(y);
    console.log(m);
    console.log(d);
    console.log( new Date(y, m, d,0,0));
  }
  confirm = () => {
    console.log(this.state.from , this.state.to);
    if(typeof this.props.close === 'function')
        this.props.close(this.state.from , this.state.to);
  }
  noProp = (evt) => {
  
      evt.stopPropagation();
      evt.nativeEvent.stopImmediatePropagation();
  }
  months = ['January', 'February','March','April','May','June','July','August','September','October','November','December'];
  render() {
      var cal_length = this.daysInMonth(this.monthStart.getMonth(), this.monthStart.getFullYear());
      var dN = this.monthStart.getDay();
      var days = [];
      console.log(this.state);
      if (dN == 0){
        dN = 7;
      }
      for (var d = 1; d < dN; d++){
        days.push(<div className="spacer day"></div>);
      }
      for (var d = 1; d <= cal_length; d++){
        var className = 'day';
        if(this.state.range){
          if(this.state.from && this.state.from < new Date(this.monthStart.getFullYear(), this.monthStart.getMonth(), d) && (this.state.to && this.state.to > new Date(this.monthStart.getFullYear(), this.monthStart.getMonth(), d))){
            className += ' during'
          }
          else if(this.state.from && this.state.from.valueOf() == new Date(Date.UTC(this.monthStart.getFullYear(), this.monthStart.getMonth(), d, 0,0,0)).valueOf()){
            className += ' start'
          }
          else if(this.state.to && this.state.to.valueOf() == new Date(Date.UTC(this.monthStart.getFullYear(), this.monthStart.getMonth(), d, 0,0,0)).valueOf()){
            className += ' end'
          }
        }
        else {
          if(this.state.from && this.state.from.valueOf() == new Date(Date.UTC(this.monthStart.getFullYear(), this.monthStart.getMonth(), d, 0,0,0)).valueOf()){
            className += ' selected'
          }
        }
        days.push(<div className={className} onClick={this.setter.bind(this,d)}>{d}</div>);
      }
      var month = [];
      var week = [];
      var vda = 0;
      var i = -1;
      while (vda < days.length ){
        for (var w = 0; w <= 6; w++){
          if(w === 0){
            i++;
            week.push([]);
          }
          var d_ = 'day d_' + w;
          week[i].push(<div className={d_}>{days[vda]}</div>);
          vda++;
        }
      }
      var wS = [];
      week.forEach(w => {
        var dS = [];
        w.forEach(d => {
          dS.push(d);
        });
        wS.push(<div className="woche">{dS}</div>);
      });
      
      var confBtn;
      if((this.props.range && this.state.to && this.state.from) || this.state.from ){
         confBtn = <div className="confirm" onClick={this.confirm}>Confirm</div>
      }
      console.log(week);
      return (
        <div ref={this.myRef} className="Calendar" onClick={this.noProp}>
          <div className="calHeader">
          <div className="bkBtn"  onClick={this.backMonth} >&laquo;</div>
          <div className="mnth">{this.months[this.monthStart.getMonth()]} {this.monthStart.getFullYear()}</div>
          <div className="frBtn" onClick={this.foreMonth} >&raquo;</div>
          </div>
          <div>
            {wS}
          </div>
          {confBtn}
        </div>
      )
    }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/Calendar.js